import { types as questionTypes } from '../../ducks/Cards';
import { types as milestoneTypes } from '../../ducks/Milestones';
import { types as deliveryTypes } from '../../ducks/Deliveries';

export default {
  [questionTypes.FETCH_POSSIBLE_RESPONSIBLE_SUCCESS]: {
    category: 'cards.possible_responsible',
    action: 'fetch',
  },
  [questionTypes.FETCH_POSSIBLE_RESPONSIBLE_ERROR]: (action: any) => ({
    category: 'cards.possible_responsible',
    action: 'fetch.error',
    label: `trace_id: ${
      action.payload.error && action.payload.error.response && action.payload.error.response.data.trace_id
    }`,
  }),
  [milestoneTypes.FETCH_MILESTONE_POSSIBLE_RESPONSIBLE_SUCCESS]: {
    category: 'milestones.possible_responsible',
    action: 'fetch',
  },
  [milestoneTypes.FETCH_MILESTONE_POSSIBLE_RESPONSIBLE_ERROR]: (action: any) => ({
    category: 'milestones.possible_responsible',
    action: 'fetch.error',
    label: `trace_id: ${
      action.payload.error && action.payload.error.response && action.payload.error.response.data.trace_id
    }`,
  }),
  [deliveryTypes.FETCH_DELIVERY_POSSIBLE_RESPONSIBLE_SUCCESS]: {
    category: 'deliveries.possible_responsible',
    action: 'fetch',
  },
  [deliveryTypes.FETCH_DELIVERY_POSSIBLE_RESPONSIBLE_ERROR]: (action: any) => ({
    category: 'deliveries.possible_responsible',
    action: 'fetch.error',
    label: `trace_id: ${
      action.payload.error && action.payload.error.response && action.payload.error.response.data.trace_id
    }`,
  }),
};
